import { render, staticRenderFns } from "./dg-state.vue?vue&type=template&id=ca651090&scoped=true"
import script from "./dg-state.vue?vue&type=script&lang=js"
export * from "./dg-state.vue?vue&type=script&lang=js"
import style0 from "./dg-state.vue?vue&type=style&index=0&id=ca651090&prod&lang=less&scoped=true"
import style1 from "./dg-state.vue?vue&type=style&index=1&id=ca651090&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca651090",
  null
  
)

export default component.exports